import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';
import TpSlTriggerPercentBasisOption from './TpSlTriggerPercentBasisModalOption';
import { DEFAULT_TP_SL_TRIGGER_PERCENT_BASIS } from 'src/components/TradeForm/TpSlOrderForm/consts';
import useModal from 'src/components/Modals/hooks/useModal';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';

export default function TpSlTriggerPercentBasisModal() {
	const { hide } = useModal();

	const [triggerPercentBasis, setTriggerPercentBasis] = useSyncLocalStorage(
		'tradeFormTpSlTriggerPercentBasis',
		DEFAULT_TP_SL_TRIGGER_PERCENT_BASIS
	);

	return (
		<ResponsiveModal.Container
			onClose={hide}
			dataTestId="tpsl-trigger-percent-basis-modal"
		>
			<ResponsiveModal.Title closeButtonTestId="tpsl-trigger-percent-basis-modal-close">
				TP/SL price setting
			</ResponsiveModal.Title>
			<ResponsiveModal.Body className="gap-y-4">
				<TpSlTriggerPercentBasisOption
					title="Price %"
					description="Set TP/SL trigger price based on percentage change relative to the entry price"
					isSelected={triggerPercentBasis === 'price'}
					handleSelect={() => setTriggerPercentBasis('price')}
				/>
				<TpSlTriggerPercentBasisOption
					title="ROI %"
					description="Set TP/SL trigger price based on estimated ROI %"
					isSelected={triggerPercentBasis === 'roi'}
					handleSelect={() => setTriggerPercentBasis('roi')}
				/>
			</ResponsiveModal.Body>
		</ResponsiveModal.Container>
	);
}
